// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"e8494346","453":"15f162cf","712":"747e975e"}[chunkId] + ".chunk.js";
};